<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">学生管理</Breadcrumb-item>
        <Breadcrumb-item>体验名单</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="110" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="8">
            <Form-item label="创建时间：">
              <Row>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="startTimeDateChange" v-model="startTimeDate" style="width: 100%;"></Date-picker>
                </Col>
                <Col span="2" style="text-align: center"> -</Col>
                <Col span="11">
                  <Date-picker type="datetime" format="yyyy-MM-dd HH:mm" placeholder="请选择日期"
                               @on-change="endTimeDateChange" v-model="endTimeDate" style="width: 100%;"></Date-picker>
                </Col>
              </Row>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="昵称：" prop="nickname">
              <Input placeholder="支持模糊搜索" name="nickname" v-model="queryParam.nickname"/>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="推荐人ID：" prop="inviteId">
              <Input placeholder="不支持模糊查询" name="inviteId" v-model="queryParam.inviteId"/>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="推荐人学导名称：" prop="referrerStudyAdviserName">
              <Input placeholder="支持模糊查询" name="referrerStudyAdviserName"
                     v-model="queryParam.referrerStudyAdviserName"/>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="学生ID：" prop="uid">
              <Input placeholder="不支持模糊搜索" name="mobile" v-model="queryParam.uid"/>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="联系电话：" prop="mobile">
              <Input placeholder="支持模糊搜索" name="mobile" v-model="queryParam.mobile"/>
            </Form-item>
          </Col>
          <Col :span="8">
            <FormItem label="归属活动：">
              <activity-select v-model="queryParam.stdTab"></activity-select>
              <!-- <Select v-model="queryParam.stdTab" clearable placeholder="请选择">
                <Option v-for="item in $constant.stdTab" :value="item.code" :key="item.code">{{item.text}}</Option>
              </Select> -->
            </FormItem>
          </Col>
          <Col :span="8">
            <Form-item label="微信号：" prop="wechatAccount">
              <Input placeholder="支持模糊搜索" name="wechatAccount" v-model="queryParam.wechatAccount"/>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="渠道：">
              <channel-select v-model="queryParam.regType"></channel-select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="市场专员" prop="marketUserId">
              <admin-user-select :status="1" adminGroupCode="market" v-model="queryParam.marketUserId">
              </admin-user-select>
            </Form-item>
          </Col>
          <Col :span="8">
            <Form-item label="注册备注：" prop="remark">
              <Input placeholder="支持模糊搜索" name="remark" v-model="queryParam.remark"/>
            </Form-item>
          </Col>
        </Row>
        <div class="export">

        </div>
      </Form>

      <div class="button-container">

        <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search" @click="search">
          搜索
        </Button>

        <div class="spacer"></div>

        <Row>
            <Button type="primary" icon="plus-round" @click="onInsertUser">添加学生</Button>
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="archive"
                  @click="bannedUser">封禁
          </Button>
          <Button type="primary" :loading="exportLoading" :disable="exportLoading" icon="archive"
                  @click="exportExcel">导出
          </Button>
        </Row>

      </div>


    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/bookTest/list" :params="queryParam"
          :onLoading="onLoading"  @on-selection-change="selectionChange"></List>

    <UserInfoModal :value="editUser" @on-close="closeModal" :uid="uid" :successCallback="search"></UserInfoModal>
    <Modal title="编辑渠道" v-model="showEditRegTypeModal">
      <Form class="form" ref="editRegType" :model="regTypeForm" :rules="regTypeRule">
        <Row>
          <Col :span="20">
            <Form-item label="渠道" prop="regType" :label-width="70">
              <channel-select v-model="regTypeForm.regType"></channel-select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showEditRegTypeModal = false">取消</Button>
        <Button type="error" size="large" :loading="loadingEditRegType" @click="editRegType">确定</Button>
      </div>
    </Modal>


    <Modal title="修改推荐人" v-model="showEditReferrerModal">
      <Form class="form" ref="editReferrer" :model="referrerForm">
        <Row>
          <Col :span="20">
            <StudentSelect v-model="referrerForm.inviteId" :label="inviteName"></StudentSelect>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showEditReferrerModal = false">取消</Button>
        <Button type="error" size="large" :loading="loadingEditReferrer" @click="editReferrer">确定</Button>
      </div>
    </Modal>

    <Modal title="修改首次分配顾问" v-model="showEditFirstConsultantModal">
      <Form class="form" ref="editFirstConsultant" :model="firstConsultantForm">
        <Row>
          <Col :span="20">
            <admin-user-select :status="1" adminGroupCode="adviser"
                               v-model="firstConsultantForm.adviserId"></admin-user-select>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showEditFirstConsultantModal = false">取消</Button>
        <Button type="error" size="large" :loading="loadingEditFirstConsultant" @click="editFirstConsultant">确定
        </Button>
      </div>
    </Modal>
    <InsertUserModal :successCallback="search" v-model="showInsertUserModal" ></InsertUserModal>
    <BannedUserModal
      :successCallback="search"
      :userList="selectionUser"
      v-model="showBannedUserModal"/>
    <AiDrawer
      :visible.sync="aiVisible"
      :uid="aiUid"
      page-route="/user/bookTestList"
      default-task-type="SALES_FOLLOWUP"
      @on-executed="onAiExecuted"
      @on-close="onAiClose"
    />
  </div>
</template>
<script>
import UserInfoModal from '../crm/UserInfoModal.vue'
import StudentSelect from '../common/StudentSelect.vue'
import BannedUserModal from './BannedUserModal.vue'
import InsertUserModal from './modal/InsertUserModal.vue'
import AiDrawer from '@/components/ai/AiDrawer'
import { bindAiAllowed } from '@/tools/aiAccess'

export default {
  components: {
    InsertUserModal,
    BannedUserModal,
    UserInfoModal,
    StudentSelect,
    AiDrawer
  },
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      searchLoading: false,
      exportLoading: false,
      editUser: false,
      uid: null,
      reload: 0,
      aiVisible: false,
      aiUid: null,
      aiAllowed: false,
      queryParam: {
        uid: null,
        stdTab: null,
        tchChannel: null,
        startTime: '',
        endTime: '',
        nickname: '',
        mobile: '',
        inviteId: null,
        referrerStudyAdviserName: '',
        regType: '',
        marketUserId: '',
        wechatAccount: '',
        remark: ''
      },
      showBannedUserModal: false,
      showInsertUserModal: false,
      selectionUser: [],
      startTimeDate: '',
      endTimeDate: '',
      isSynchronizeList: [
        {code: 1, text: '成功'},
        {code: 2, text: '手动同步'},
        {code: 3, text: '失败'},
        {code: 4, text: '未同步'}
      ],
      title: [
        {
          type: 'selection',
          width: 40,
          fixed: 'left',
          align: 'center'
        },
        {
          title: '学生ID',
          fixed: 'left',
          width: 80,
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openInfoModal(row.id)}}, row.id)
          }
        },
        {
          title: '昵称',
          width: 130,
          fixed: 'left',
          render: (h, params) => {
            let nickName = params.row.nickname
            let inviteId = params.row.inviteId
            if (inviteId) {
              return h('span',
                [
                  h('span', nickName),
                  h('span', {style: {color: 'red'}}, '(推荐)')
                ]
              )
            } else {
              return h('span', nickName)
            }
          }
        },
        {
          title: '年龄',
          width: 70,
          key: 'age'
        },
        {
          title: '微信号',
          width: 90,
          key: 'wechatAccount'
        },
        {
          title: '手机号',
          align: 'center',
          width: 130,
          key: 'mobile',
          render: (h, params) => {
            if (params.row.mobile.startsWith('n')) {
              return h('span', '')
            }
            return h('Poptip', {
              props: {
                trigger: 'hover'
              }
            }, [
              h('span', {}, params.row.mobile),
              // 当前行展示的数据
              h('div', {slot: 'content'}, params.row.mobile)
            ])
          }
        },
        {
          title: '创建时间',
          align: 'center',
          width: 170,
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '省',
          width: 80,
          align: 'center',
          key: 'province'
        },
        {
          title: '市',
          width: 80,
          align: 'center',
          key: 'city'
        },
        {
          title: '渠道',
          width: 110,
          align: 'center',
          key: 'regType',
          // render: (h, params) => {
          //   let regType = params.row.regType
          //   if (regType) {
          //     let type = $constant.getEnum($constant.studentCanal, regType)
          //     if (type) {
          //       return h('span', type.text)
          //     } else {
          //       return h('span', regType)
          //     }
          //   } else {
          //     return h('span', '')
          //   }
          // }
        },
        {
          title: '渠道来源',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let tchChannel = params.row.tchChannel
            let tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel)
            return h('div', tchChannelEnum && tchChannelEnum.text)
          }
        },
        {
          title: '归属活动',
          width: 110,
          align: 'center',
          key: 'stdTabText',
          // render: (h, params) => {
          //   let stdTab = params.row.stdTab
          //   if (stdTab) {
          //     let type = $constant.getEnum($constant.stdTab, stdTab)
          //     if (type) {
          //       return h('span', type.text)
          //     } else {
          //       return h('span', stdTab)
          //     }
          //   } else {
          //     return h('span', '无活动')
          //   }
          // }
        },
        {
          title: '链接来源',
          width: 150,
          align: 'center',
          key: 'ip'
        },
        {
          title: '学生状态',
          width: 110,
          align: 'center',
          render: (h, params) => {
            let stdStatus = params.row.stdStatus
            let status = $constant.getEnum($constant.stdStatus, stdStatus)
            if (status) {
              return h('span', status.text)
            } else {
              return h('span', '')
            }
          }
        },
        {
          title: '已试听',
          width: 80,
          align: 'center',
          render: (h, params) => {
            let isAudition = params.row.isAudition
            let audition = $constant.getEnum($constant.yesNoNum, isAudition)
            if (audition) {
              return h('span', audition.text)
            } else {
              return h('span', '')
            }
          }
        },
        {
          title: '推荐人',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let referrerName = params.row.referrerName
            let inviteId = params.row.inviteId
            if (referrerName && inviteId) {
              return h('span', inviteId + '-' + referrerName)
            } else {
              return h('span', '')
            }
          }
        },
        {
          title: '推荐人学导',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let referrerStudyAdviserName = params.row.referrerStudyAdviserName
            let referrerStudyAdviserId = params.row.referrerStudyAdviserId
            if (referrerStudyAdviserName && referrerStudyAdviserId) {
              return h('span', referrerStudyAdviserId + '-' + referrerStudyAdviserName)
            } else {
              return h('span', '')
            }
          }
        },
        {
          title: '首次分配课程顾问',
          width: 150,
          align: 'center',
          key: 'firstAdviserName'
        },
        {
          title: '最终归属课程顾问',
          width: 150,
          align: 'center',
          key: 'adviserName'
        },
        {
          title: 'Follow Up',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let content = params.row.content
            if (!content) {
              return h('span', '')
            }
            return h('Poptip', {
              props: {
                trigger: 'hover',
                placement: 'top',
                transfer: true
              }
            }, [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '130px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  verticalAlign: 'middle'
                }
              }, content),
              h('div', {
                slot: 'content',
                style: {
                  maxWidth: '360px',
                  whiteSpace: 'pre-wrap',
                  wordBreak: 'break-word',
                  textAlign: 'left'
                }
              }, content)
            ])
          }
        },
        {
          title: '操作',
          width: 160,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return ('span', [
              h('a', {on: {click: () => this.showEditRegType(row)}}, '编辑渠道'),
              h('br', '  '),
              h('a', {on: {click: () => this.showEditReferrer(row)}}, '修改推荐人'),
              h('br', '  '),
              h('a', {on: {click: () => this.showEditFirstConsultant(row)}}, '修改首次顾问'),
              this.aiAllowed ? h('br', '  ') : null,
              this.aiAllowed ? h('a', {on: {click: () => this.openAiDrawer(row.id)}}, 'AI') : null,
            ])
          }
        },
      ],
      regTypeForm: {
        id: '',
        regType: ''
      },
      referrerForm: {
        uid: null,
        inviteId: null,
        referrerName: ''
      },
      regTypeRule: {
        regType: [
          {type: 'string', required: true, message: '渠道不能为空', trigger: 'blur'}
        ]
      },
      firstConsultantForm: {
        adviserId: '',
        uid: 0
      },
      showEditRegTypeModal: false,
      loadingEditRegType: false,
      loadingEditReferrer: false,
      loadingEditFirstConsultant: false,
      showEditReferrerModal: false,
      showEditFirstConsultantModal: false,
      inviteName: ''
    }
  },
  mounted: function () {
  },
  created: function () {
    bindAiAllowed(this)
    let startTime = this.queryParam.startTime
    if (startTime !== '') {
      this.startTimeDate = this.$moment.unix(startTime).toDate()
    }
    if (startTime === '') {
      let momentDate = this.$moment().add(-1, 'M')
      momentDate.millisecond(0)
      momentDate.second(0)
      momentDate.minute(0)
      momentDate.hour(0)
      this.startTimeDate = momentDate.toDate()
      this.queryParam.startTime = momentDate.format('X')
    }
  },
  methods: {
    // 添加学生
    onInsertUser () {
      this.showInsertUserModal = true
    },
    selectionChange (selection) {
      this.selectionUser = selection
    },
    openInfoModal(val) {
      this.uid = val
      let {href} = this.$router.resolve({
        name: 'userPayDetail',
        query: {uid: val, tabName: 0, parm: self.queryParam, backPath: '/user/BookTestList'}
      })
      window.open(href, '_blank')
    },
    closeModal(val) {
      this.uid = null
      this.editUser = false
      this.reload = new Date().getTime()
    },
    openAiDrawer (id) {
      this.aiUid = id
      this.aiVisible = true
    },
    onAiClose () {
      this.aiVisible = false
      this.aiUid = null
    },
    onAiExecuted () {
      this.reload = new Date().getTime()
    },
    search() {
      this.reload = new Date().getTime()
    },
    onLoading(loading) {
      this.searchLoading = loading
    },
    startTimeDateChange(value) {
      this.queryParam.startTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },
    endTimeDateChange(value) {
      this.queryParam.endTime = value && this.$moment(value, 'YYYY-M-D H:m').format('X')
    },

    exportExcel () {
      let self = this
      self.exportLoading = true
      self.$http.get('/bookTest/exportExcel', {
        responseType: 'arraybuffer',
        params: self.queryParam
      }).then(function (response) {
        let blob = new Blob([response.data], {type: 'application/vnd.ms-excel'})
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = '学生体验名单.xls'
        link.click()
        self.exportLoading = false
      }).catch(function (e) {
        self.exportLoading = false
      })
    },

    bannedUser () {
      if (this.selectionUser.length <= 0) {
        this.$Message.warning('请选择需封禁的学生！')
        return
      }
      this.showBannedUserModal = true
    },
    showEditRegType (row) {
      this.showEditRegTypeModal = true
      this.regTypeForm.id = row.id
      this.regTypeForm.regType = row.regType
    },
    showEditReferrer(row) {
      this.showEditReferrerModal = true
      this.referrerForm.uid = row.id
      this.referrerForm.inviteId = row.inviteId
    },
    showEditFirstConsultant(row) {
      this.showEditFirstConsultantModal = true
      this.firstConsultantForm.uid = row.id
    },
    showIPBanned (row) {
      this.showEditFirstConsultantModal = true
      this.firstConsultantForm.uid = row.id
    },
    editRegType() {
      let self = this
      self.loadingEditRegType = true
      self.$refs.editRegType.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingEditRegType = false
          return
        }
        let params = {}
        params.id = self.regTypeForm.id
        params.regType = self.regTypeForm.regType
        self.$http.post('/bookTest/editRegType', params).then(function (res) {
          if (res && res.data > 0) {
            self.search()
            self.showEditRegTypeModal = false
          }
          self.loadingEditRegType = false
        }).catch(function (e) {
          self.showEditRegTypeModal = false
          self.loadingEditRegType = false
        })
      })
    },
    editReferrer() {
      let self = this
      self.loadingEditReferrer = true
      let params = {}
      params.uid = self.referrerForm.uid
      params.referrerId = self.referrerForm.inviteId
      if (!params.uid || !params.referrerId) {
        self.$Message.warning('信息输入错误!')
        self.loadingEditReferrer = false
        return
      }
      self.$http.post('/user/editReferrer', params).then(function (res) {
        if (res && res.data > 0) {
          self.search()
          self.showEditReferrerModal = false
        }
        self.loadingEditReferrer = false
      }).catch(function (e) {
        self.showEditReferrerModal = false
        self.loadingEditReferrer = false
      })
      self.referrerForm = []
      params = {}
    },
    editFirstConsultant() {
      let self = this
      self.loadingEditFirstConsultant = true

      self.$http.get('/userList/updateFirstAdviserId?uid=' + self.firstConsultantForm.uid + '&firstAdviserId=' + self.firstConsultantForm.adviserId).then(function (res) {
        if (res && res.status == "ok") {
          self.$Message.success('修改成功!')
          self.search()
          self.showEditFirstConsultantModal = false
        }
        self.loadingEditFirstConsultant = false
      }).catch(function (err) {
        self.$Message.error(err)
        self.showEditFirstConsultantModal = false
        self.loadingEditFirstConsultant = false
      })
    }
  }
}

</script>



<style scoped>
.margin {
  padding-left: 15px;
  margin-bottom: 20px;
}

.button-container {
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-button {
  align-self: flex-start;
}

.right-button {
  align-self: flex-end;
}

.spacer {
  flex: 1;
}

.bg {
  background-color: red;
}

.flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// BookTestList.vue?89313fa6